import { REQUEST, SUCCESS, FAILURE } from 'redux-config/reduxHelpers';
import * as ActionTypes from './actions';

export const initialState = {
  announcements: [],
  announcementsAreLoaded: false,
  announcementDetail: null,
  isCreating: false,
  isUpdating: false,
  isDeleting: false,
  isToggling: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.GET_ANNOUNCEMENTS_LIST[REQUEST]:
      return { ...state, announcementsAreLoaded: false };
    case ActionTypes.GET_ANNOUNCEMENTS_LIST[SUCCESS]:
      return { ...state, announcements: action.data, announcementsAreLoaded: true };

    case ActionTypes.GET_ANNOUNCEMENT_DETAIL[SUCCESS]:
      return { ...state, announcementDetail: action.data };

    case ActionTypes.CREATE_ANNOUNCEMENT[REQUEST]:
      return { ...state, isCreating: true };
    case ActionTypes.CREATE_ANNOUNCEMENT[SUCCESS]:
      return { ...state, isCreating: false };

    case ActionTypes.UPDATE_ANNOUNCEMENT[REQUEST]:
      return { ...state, isUpdating: true };
    case ActionTypes.UPDATE_ANNOUNCEMENT[SUCCESS]:
      return { ...state, isUpdating: false, announcementDetail: action.data };

    case ActionTypes.DELETE_ANNOUNCEMENT[REQUEST]:
      return { ...state, isDeleting: true };
    case ActionTypes.DELETE_ANNOUNCEMENT[SUCCESS]:
      return { ...state, isDeleting: false };

    case ActionTypes.TOGGLE_ANNOUNCEMENT[REQUEST]:
      return { ...state, isToggling: true };
    case ActionTypes.TOGGLE_ANNOUNCEMENT[SUCCESS]:
    case ActionTypes.TOGGLE_ANNOUNCEMENT[FAILURE]: {
      const updatedAnnouncement = action.data;
      const updatedList = state.announcements.map(item =>
        item.id === updatedAnnouncement.id ? updatedAnnouncement : item
      );
      return { ...state, announcements: updatedList, isToggling: false };
    }

    default:
      return state;
  }
};

export default reducer;
